module.exports = __webpack_public_path__ + "static/media/reacttraining-code-bg1.nl.40f22628.png";